/**
 * @generated SignedSource<<2d10247936629556aad10265525a834c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiPresetCategoriesQuery$variables = {
  presetType?: string | null;
  toolId: string;
};
export type aiPresetCategoriesQuery$data = {
  readonly aiPresetCategories: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly sellerID: number | null;
  }>;
};
export type aiPresetCategoriesQuery = {
  response: aiPresetCategoriesQuery$data;
  variables: aiPresetCategoriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "presetType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "toolId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "presetType",
        "variableName": "presetType"
      },
      {
        "kind": "Variable",
        "name": "toolId",
        "variableName": "toolId"
      }
    ],
    "concreteType": "AIPresetCategoryDTO",
    "kind": "LinkedField",
    "name": "aiPresetCategories",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sellerID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiPresetCategoriesQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "aiPresetCategoriesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a3fa25e0b6c98f81dc29e1827d846af8",
    "id": null,
    "metadata": {},
    "name": "aiPresetCategoriesQuery",
    "operationKind": "query",
    "text": "query aiPresetCategoriesQuery(\n  $toolId: String!\n  $presetType: String\n) {\n  aiPresetCategories(toolId: $toolId, presetType: $presetType) {\n    id\n    name\n    sellerID\n  }\n}\n"
  }
};
})();

(node as any).hash = "160a0452fa219def40460f614d6767fd";

export default node;
